import { createGenericStore } from './genericStore';

export const useDoctorsComboStore = createGenericStore(
  'doctorsCombo',
  '/Doctor/GetAllAsync',
  {
    searchColumns: ['fDname', 'fDtakhasos', 'fDnezamno'],
    orderBy: 'fDname ASC'
  }
);